export default __webpack_public_path__ + "static/media/15_kura.14e0dad9.png";